var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-4",attrs:{"mobile-breakpoint":"0","items-per-page":5,"options":_vm.studentTableOptions,"item-key":"studentCode","headers":_vm.originHeaders,"items":_vm.priceStudent,"footer-props":{
    'items-per-page-text': 'Hiển thị mỗi trang',
    'items-per-page-all-text': 'Tất cả',
  },"disable-sort":""},on:{"update:options":function($event){_vm.studentTableOptions=$event}},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.index)+"\n  ")]}},{key:"item.student",fn:function(ref){
  var item = ref.item;
return [_c('CardStudentName',{attrs:{"student":item,"link":""}})]}},{key:"item.dob",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("ddmmyyyy")(item.dob))+"\n  ")]}},{key:"item.gender",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("gender")(item.gender))+"\n  ")]}},{key:"item.class",fn:function(ref){
  var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.currentClass.title)+"\n  ")]}},{key:"item.status",fn:function(ref){
  var item = ref.item;
return [_c('v-chip',{attrs:{"small":"","color":_vm._f("statusColor")(item.status)}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm._f("status")(item.status)))])])]}},{key:"item.price",fn:function(ref){
  var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.price && item.price.toLocaleString('en-US'))+_vm._s(item.price && item.type === 'percentage' ? '%' : ' VNĐ'))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }